import(/* webpackMode: "eager", webpackExports: ["BestSellingPackage"] */ "/home/ec2-user/website/salontymwebweb/app/components/best-selling/BestSellingPackage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ec2-user/website/salontymwebweb/app/components/category-header/CategoryHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClaimServices"] */ "/home/ec2-user/website/salontymwebweb/app/components/claim-service/ClaimServices.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ec2-user/website/salontymwebweb/app/components/faq/Faq.tsx");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/website/salontymwebweb/app/components/features/features.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ec2-user/website/salontymwebweb/app/components/footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ec2-user/website/salontymwebweb/app/components/genericComponents/all-carts/AllCartsSlide.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MainLoader"] */ "/home/ec2-user/website/salontymwebweb/app/components/genericComponents/MainLoader/MainLoader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GetAppButton"] */ "/home/ec2-user/website/salontymwebweb/app/components/get-app-button/GetAppButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ec2-user/website/salontymwebweb/app/components/get-app/GetApp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ec2-user/website/salontymwebweb/app/components/home/HomePageCards.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Instruction"] */ "/home/ec2-user/website/salontymwebweb/app/components/instructions/Instruction.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterNavigation"] */ "/home/ec2-user/website/salontymwebweb/app/components/mobile-componenet/FooterNavigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavbarWraper"] */ "/home/ec2-user/website/salontymwebweb/app/components/navbar/NavbarWraper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Offers"] */ "/home/ec2-user/website/salontymwebweb/app/components/offers/Offers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Plans"] */ "/home/ec2-user/website/salontymwebweb/app/components/plans/Plans.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QuickCheckOut"] */ "/home/ec2-user/website/salontymwebweb/app/components/quick-checkout/QuickCheckout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ec2-user/website/salontymwebweb/app/components/review/Review.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SalonTymCoinsVisit"] */ "/home/ec2-user/website/salontymwebweb/app/components/salonTym-coins/SalonTymCoinsVisit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UpIcon"] */ "/home/ec2-user/website/salontymwebweb/app/components/up-icon/UpIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ec2-user/website/salontymwebweb/app/components/video/Video.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ec2-user/website/salontymwebweb/app/components/video/VideoSlider.tsx");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/website/salontymwebweb/app/dummydata/banner.jpg");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/website/salontymwebweb/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ec2-user/website/salontymwebweb/node_modules/@mui/icons-material/AccessTimeOutlined.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ec2-user/website/salontymwebweb/node_modules/@mui/icons-material/SpaOutlined.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ec2-user/website/salontymwebweb/node_modules/@mui/icons-material/VerifiedOutlined.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ec2-user/website/salontymwebweb/node_modules/@mui/icons-material/WorkspacePremiumOutlined.js");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/website/salontymwebweb/node_modules/@mui/material/Box/index.js");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/website/salontymwebweb/node_modules/@mui/material/Typography/index.js");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/website/salontymwebweb/node_modules/slick-carousel/slick/slick.css");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/website/salontymwebweb/node_modules/slick-carousel/slick/slick-theme.css");
